import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Table, Card } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next"; // For translations
import FileUploader from "../../../reusableComponents/FileUploader2";
import { useSelector } from "react-redux";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { garbageCollection, publicSewerageOrSepticTank, solidWasteDisposal, yesNoRadioList } from "../../../../TCPForms/data";
import { validateChecklist } from "../helpers/helpers";

const Checklist = ({ formData, isUpdating, handleTabChange, t, Modal }) => {
  const { documents } = useSelector((state) => state.formMT);
  const [showError, setShowError] = useState(false);

  const defaultValues = {
    ...formData,

    documents,
  };
  const validateFiles = () => {
    const uploadedDocs = new Set(documents?.map((doc) => doc.documentType));
    const requiredDocs =
      watch("checklist.firstCheckList.structuralSafety") === "Yes"
        ? ["proposalDocument", "parkingProposalDoc", "drawingFile", "structuralCertificate", "fireDepartmentCertificate"]
        : ["proposalDocument", "parkingProposalDoc", "drawingFile"];
    if (watch("checklist.firstCheckList.fireNocRequired") === "Yes") {
      requiredDocs.push("fireDepartmentCertificate");
    }

    return requiredDocs.every((doc) => uploadedDocs.has(doc));
  };
  const handleFormSubmit = (data) => {
    const isValid = validateFiles();
    const { message, isChecklistValid } = validateChecklist(data);
    console.log("messageFromValidation", message, isChecklistValid);

    if (isValid && !isChecklistValid) {
      Modal("Invalid Request", `${message}`, "error");
      return;
    }
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  const { control, handleSubmit, watch, reset, setValue } = useForm({ defaultValues });
  const firstCheckList = formData?.checklist?.firstCheckList;
  const secondCheckList = formData?.checklist?.secondCheckList;
  const totalParkingRequired = watch("checklist.firstCheckList.totalParkingRequired");
  const totalParkingProposed = watch("checklist.firstCheckList.totalParkingProposed");
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const onSubmit = (data) => {
    // data = {
    //   ...data,
    //   documents: [...formData?.documents, ...documents],
    // };
    console.log("dataFromChecklist", data);
    handleTabChange(3, data);
  };

  return (
    <div className="groupContainer2">
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Checklist 1</h2>
          </div>
          <Table bordered className="table-checklist">
            <thead className="table-header">
              <tr>
                <th>Field Name</th>
                <th>User Input</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={2} className="table-subheader">
                  <strong>{t("LABEL_SETBACK_POSITION")}</strong>
                </td>
              </tr>
              {["Front", "Rear", "SSB1", "SSB2"].map((position) => (
                <tr key={`${position}`}>
                  <td>
                    {`${position} (M)`}
                    <span className="compulsoryField"> *</span>
                  </td>
                  <td>
                    <InputWrapper
                      name={`checklist.firstCheckList.setbackPosition.${position.toLowerCase()}`}
                      defaultValue={firstCheckList?.setbackPosition?.[position.toLowerCase()] || ""}
                      type="number"
                      hasLabel={false}
                      mandatory
                      maxLength={2}
                      validation={{
                        required: { value: true, message: "This field is required." },
                      }}
                      control={control}
                    />
                  </td>
                </tr>
              ))}
              <tr>
                <td>
                  Height of Proposed Building (m)<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <InputWrapper
                    name="checklist.firstCheckList.buildingHeight"
                    // defaultValue={firstCheckList?.buildingHeight || ""} // Added default value
                    type="number"
                    hasLabel={false}
                    mandatory
                    maxLength={2}
                    validation={{
                      required: { value: true, message: "Please enter a height." },
                    }}
                    control={control}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  Proposal Document (PDF)<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <FileUploader
                    name="proposalDocument"
                    validationMsg="(pdf file only and Max file Size 10 MB)"
                    label={"Proposal Document (PDF)"}
                    hasLabel={false}
                    isMandatory
                    required
                    tab={1}
                    showError={showError}
                    maxFiles={1}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Drawing File (.dxf)<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <FileUploader
                    name="drawingFile"
                    validationMsg="(dxf file only and Max file Size 300 MB)"
                    label={"Drawing File (.dxf)"}
                    hasLabel={false}
                    isMandatory
                    required
                    tab={5}
                    showError={showError}
                    maxFiles={1}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Structural Safety Certificate Applicable<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <InputWrapper
                    control={control}
                    hasLabel={false}
                    defaultValue={firstCheckList?.structuralSafety || ""} // Added default value
                    name="checklist.firstCheckList.structuralSafety"
                    type="radioButton"
                    data={yesNoRadioList}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "Please select any value.",
                      },
                    }}
                  />
                </td>
              </tr>
              {watch("checklist.firstCheckList.structuralSafety") === "Yes" && (
                <tr>
                  <td>
                    Please attach Structural Safety Certificate<span className="compulsoryField"> *</span>
                  </td>
                  <td>
                    <FileUploader
                      name="structuralCertificate"
                      validationMsg="(pdf file only and Max file Size 10 MB)"
                      label={"Structural Safety Certificate"}
                      isMandatory
                      required
                      tab={1}
                      hasLabel={false}
                      showError={showError}
                      maxFiles={1}
                    />
                  </td>
                </tr>
              )}
              <tr>
                <td>
                  Is Fire NOC Required?<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <InputWrapper
                    control={control}
                    hasLabel={false}
                    defaultValue={firstCheckList?.structuralSafety || ""} // Added default value
                    name="checklist.firstCheckList.fireNocRequired"
                    type="radioButton"
                    data={yesNoRadioList}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "Please select any value.",
                      },
                    }}
                  />
                </td>
              </tr>
              {watch("checklist.firstCheckList.fireNocRequired") === "Yes" && (
                <tr>
                  <td>
                    Please attach Fire Department NOC<span className="compulsoryField"> *</span>
                  </td>
                  <td>
                    <FileUploader
                      name="fireDepartmentCertificate"
                      validationMsg="(pdf file only and Max file Size 10 MB)"
                      label={"Fire Department NOC"}
                      isMandatory
                      required
                      tab={1}
                      hasLabel={false}
                      maxFiles={1}
                      showError={showError}
                    />
                  </td>
                </tr>
              )}

              <tr>
                <td colSpan={2} className="table-subheader">
                  <strong>{t("LABEL_PARKING_ARRANGEMENT")}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  No. of Parking Required<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <InputWrapper
                    name="checklist.firstCheckList.totalParkingRequired"
                    defaultValue={firstCheckList?.totalParkingRequired || ""} // Added default value
                    type="number"
                    hasLabel={false}
                    mandatory
                    validation={{
                      required: { value: true, message: "Please enter number of parking required." },
                    }}
                    control={control}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  No of Parking Proposed (As per Map)<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <InputWrapper
                    name="checklist.firstCheckList.totalParkingProposed"
                    defaultValue={firstCheckList?.totalParkingProposed || ""} // Added default value
                    type="number"
                    hasLabel={false}
                    mandatory
                    validation={{
                      required: { value: true, message: "Please enter number of parking required." },
                    }}
                    control={control}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Upload Proposed Parking Plan<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <FileUploader
                    name="parkingProposalDoc"
                    validationMsg="(pdf file only and Max file Size 10 MB)"
                    hasLabel={false}
                    label={"Proposed Parking Plan"}
                    isMandatory
                    required
                    tab={1}
                    showError={showError}
                    maxFiles={1}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="table-subheader">
                  <strong>Parking Provision as per Proposed Plan</strong>
                </td>
              </tr>

              <tr>
                <td>
                  No. of Cars in Basement<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <InputWrapper
                    label=""
                    name="checklist.firstCheckList.parkingProvision.inBasement.cars"
                    defaultValue={firstCheckList?.parkingProvision?.inBasement?.cars || ""} // Added default value
                    type="number"
                    maxLength={6}
                    validation={{
                      required: { value: true, message: "This field is required." },
                    }}
                    hasLabel={false}
                    control={control}
                  />
                </td>
              </tr>
              {/* <tr>
                <td>
                  No. of ECS
                  <InputWrapper
                    label=""
                    name="checklist.firstCheckList.parkingProvision.inBasement.ecs"
                    defaultValue={firstCheckList?.parkingProvision?.inBasement?.ecs || ""} // Added default value
                    type="number"
                    maxLength={6}
                    validation={{
                      required: { value: true, message: "This field is required." },
                    }}
                    hasLabel={false}
                    control={control}
                  />
                </td>
              </tr> */}

              <tr>
                <td>
                  No. of Cars in Open Area<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <InputWrapper
                    label=""
                    name="checklist.firstCheckList.parkingProvision.openArea.cars"
                    defaultValue={firstCheckList?.parkingProvision?.openArea?.cars || ""} // Added default value
                    type="number"
                    maxLength={6}
                    validation={{
                      required: { value: true, message: "This field is required." },
                    }}
                    hasLabel={false}
                    control={control}
                  />
                </td>
              </tr>
              {/* <tr>
                <td>
                  No. of ECS
                  <InputWrapper
                    label=""
                    name="checklist.firstCheckList.parkingProvision.openArea.ecs"
                    defaultValue={firstCheckList?.parkingProvision?.openArea?.ecs || ""} // Added default value
                    type="number"
                    maxLength={6}
                    validation={{
                      required: { value: true, message: "This field is required." },
                    }}
                    hasLabel={false}
                    control={control}
                  />
                </td>
              </tr> */}

              <tr>
                <td>
                  No. of Cars in Stilt Area<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <InputWrapper
                    label=""
                    name="checklist.firstCheckList.parkingProvision.inStiltArea.cars"
                    defaultValue={firstCheckList?.parkingProvision?.inStiltArea?.cars || ""} // Added default value
                    type="number"
                    maxLength={6}
                    validation={{
                      required: { value: true, message: "This field is required." },
                    }}
                    hasLabel={false}
                    control={control}
                  />
                </td>
              </tr>
              {/* <tr>
                <td>
                  No. of ECS
                  <InputWrapper
                    label=""
                    name="checklist.firstCheckList.parkingProvision.inStiltArea.ecs"
                    defaultValue={firstCheckList?.parkingProvision?.inStiltArea?.ecs || ""} // Added default value
                    type="number"
                    maxLength={6}
                    validation={{
                      required: { value: true, message: "This field is required." },
                    }}
                    hasLabel={false}
                    control={control}
                  />
                </td>
              </tr> */}
            </tbody>
          </Table>
        </div>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Checklist 2</h2>
          </div>
          <Table bordered className="table-checklist">
            <thead className="table-header">
              <tr>
                <th>Field Names</th>
                <th>User Inputs</th>
              </tr>
            </thead>
            <tbody>
              {/* Sewerage Section */}
              {/* <tr>
                <td colSpan={2} className="table-subheader">
                  <strong>Sewerage (including stormwater)</strong>
                </td>
              </tr>*/}
              <tr>
                <td>
                  Existing road width in meters<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="number"
                    name="checklist.secondCheckList.existingRoadWidth"
                    control={control}
                    hasLabel={false}
                    defaultValue={secondCheckList?.existingRoadWidth || ""} // Added default value
                    validation={{
                      required: { value: true, message: "Please enter the road width." },
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Provision of Sewerage & Drainage<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  {/* <InputWrapper type="checkbox" name="checklist.secondCheckList.publicSewerageOrSepticTank" control={control} /> */}
                  <InputWrapper
                    control={control}
                    // labelWidth={"70%"}
                    // label={question.label}
                    hasLabel={false}
                    name={"checklist.secondCheckList.publicSewerageOrSepticTank"}
                    type="radioButton"
                    data={publicSewerageOrSepticTank}
                    // {...register("checklist.secondCheckList.publicSewerageOrSepticTank")}
                    defaultValue={secondCheckList?.publicSewerageOrSepticTank} // Use defaultChecked
                    validation={{
                      required: { value: true, message: "Please select any value." },
                    }}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  Provision of Water Supply<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="radioButton"
                    name="checklist.secondCheckList.waterSupplyArrangement"
                    control={control}
                    hasLabel={false}
                    data={yesNoRadioList}
                    defaultValue={secondCheckList?.waterSupplyArrangement || ""} // Added default value
                    validation={{
                      required: { value: true, message: "Please select any value." },
                    }}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  Mode of Solid waste disposal
                  <span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="radioButton"
                    data={solidWasteDisposal}
                    name="checklist.secondCheckList.solidWasteDisposal"
                    control={control}
                    hasLabel={false}
                    validation={{
                      required: { value: true, message: "Please select any value." },
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Mode of Garbage collection<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="radioButton"
                    data={garbageCollection}
                    name="checklist.secondCheckList.garbageCollection"
                    control={control}
                    hasLabel={false}
                    validation={{
                      required: { value: true, message: "Please select any value." },
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Provision of Power supply<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="radioButton"
                    name="checklist.secondCheckList.powerSupply"
                    control={control}
                    hasLabel={false}
                    data={yesNoRadioList}
                    defaultValue={secondCheckList?.powerSupply || ""} // Added default value
                    validation={{
                      required: { value: true, message: "Please select any value." },
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Provision of Rain Water Harvesting<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="radioButton"
                    name="checklist.secondCheckList.rainWaterHarvesting"
                    control={control}
                    hasLabel={false}
                    data={yesNoRadioList}
                    defaultValue={secondCheckList?.rainWaterHarvesting || ""} // Added default value
                    validation={{
                      required: { value: true, message: "Please select any value." },
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Provision of Solar Water Heating system<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="radioButton"
                    name="checklist.secondCheckList.solarWaterHeating"
                    control={control}
                    hasLabel={false}
                    data={yesNoRadioList}
                    defaultValue={secondCheckList?.solarWaterHeating || ""} // Added default value
                    validation={{
                      required: { value: true, message: "Please select any value." },
                    }}
                  />
                </td>
              </tr>
              {/* Power Supply Section */}
              {/* <tr>
                <td colSpan={2} className="table-subheader">
                  <strong>Power Supply</strong>
                </td>
              </tr>
              <tr>
                <td>
                  Total estimated power demand (kW/MW)<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="number"
                    name="checklist.secondCheckList.totalEstimatedPowerDemand"
                    control={control}
                    hasLabel={false}
                    defaultValue={secondCheckList?.totalEstimatedPowerDemand || ""} // Added default value
                    validation={{
                      required: { value: true, message: "Please enter the power demand." },
                    }}
                  />
                </td>
              </tr> */}
              {/* <tr>
                <td>
                  Corporation Ltd. has consent for supply in respect of proposed Garg. Power received<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper type="checkbox" name="checklist.secondCheckList.powerSupplyConsent" control={control} />
                </td>
              </tr> */}

              {/* Roof-top Rainwater Harvesting System Section */}
              {/* <tr>
                <td colSpan={2} className="table-subheader">
                  <strong>Roof-top Rainwater Harvesting System</strong>
                </td>
              </tr> */}
              {/* <tr>
                <td>
                  Total area of rooftop (sq. meters) and provision of drain pipe and recharge pit<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="number"
                    name="checklist.secondCheckList.rooftopAreaAndDrainage"
                    control={control}
                    hasLabel={false}
                    defaultValue={secondCheckList?.rooftopAreaAndDrainage || ""} // Added default value
                    validation={{
                      required: { value: true, message: "Please enter the rooftop area." },
                    }}
                  />
                </td>
              </tr> */}
              {/* <tr>
                <td>
                  Found to be as per standard / not<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper type="checkbox" name="checklist.secondCheckList.drainageStandardsCompliance" control={control} />
                </td>
              </tr> */}

              {/* Solar Water System Section */}
              {/* <tr>
                <td colSpan={2} className="table-subheader">
                  <strong>Solar Water System</strong>
                </td>
              </tr> */}
              {/* <tr>
                <td>
                  Provision of pipes in the building design for solar water heating system and determination of suitable location for the plant on the
                  rooftop.<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="checkbox"
                    name="checklist.secondCheckList.solarWaterHeatingProvision"
                    control={control}
                    defaultValue={secondCheckList?.solarWaterHeatingProvision} // Added default value
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Whether provision made as per building bye-laws or not<span className="compulsoryField"> *</span>
                </td>
                <td className="table-input">
                  <InputWrapper
                    type="checkbox"
                    name="checklist.secondCheckList.buildingByeLawsCompliance"
                    control={control}
                    defaultValue={secondCheckList?.buildingByeLawsCompliance} // Added default value
                  />
                </td>
              </tr> */}
            </tbody>
          </Table>
        </div>
        <div className="footerContainer2">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
              onClick={() => handleTabChange(1)}
            />
            <ButtonWrapper
              variant="contained"
              color="success"
              size="medium"
              label="Save"
              type="submit"
              sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Checklist;
